import React, { memo, useContext, useState } from "react";
import { makeStyles } from "@mui/styles";
import { MenuBook, PictureAsPdf } from "@mui/icons-material";
import {
  Box,
  TextField,
  MenuItem,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  DialogTitle,
  Dialog,
  DialogContent,
  ListItemButton,
} from "@mui/material";

import AuthContext from "../../../../Context/Auth/AuthContext";
import Cargando from "../../../../components/Extra/Cargando";
import { usePermiso } from "../../../../hooks/usePermiso";
import ConfirmacionDialog from "../../../../components/Extra/ConfirmacionDialog";

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  delete: {
    backgroundColor: theme.palette.error.main,
  },
  bg: {
    backgroundColor: theme.palette.primary.dark,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
  },
}));
const ExportDialog = (props) => {
  const { alertaPermiso, tienePermiso } = usePermiso("Facturacion");
  const classes = useStyles();
  const { usuario } = useContext(AuthContext);
  const {
    open,
    setopen,
    funcPdf,
    funcExcel,
    arrayExport,
    mes,
    setmes,
    tabla,
    socket,
    funcExcel2,
  } = props;
  const [cargando, setcargando] = useState(false);
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  const handleEliminar = async () => {
    if (tienePermiso && !tienePermiso("eliminar")) {
      return alertaPermiso("eliminar");
    }

    await setcargando(true);

    await setTimeout(async () => {
      socket.current.emit("client:eliminarDataSeleccionado", {
        rucempresa: usuario.rucempresa,
        rol: usuario.rol,
        tabla,
        lista: arrayExport,
      });
      setcargando(false);
      setopen(false);
    }, 500);
  };
  return (
    <>
      <ConfirmacionDialog
        open={openConfirmDialog}
        setopen={setopenConfirmDialog}
        titulo={`¿Esta seguro de eliminar estos registros?`}
        funcion={handleEliminar}
      />
      <Dialog
        onClose={() => setopen(false)}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <Box padding={2}>
          <DialogTitle id="simple-dialog-title">Opciones.</DialogTitle>
          <DialogContent>
            {cargando ? (
              <Cargando titulo="Cargando." />
            ) : (
              <>
                <List>
                  <ListItemButton
                    disabled={cargando || arrayExport.length === 0}
                    onClick={async () => {
                      await setcargando(true);

                      await setTimeout(async () => {
                        await funcPdf();

                        setcargando(false);
                        setopen(false);
                      }, 500);
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar className={classes.avatar}>
                        <PictureAsPdf />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Exportar" />
                  </ListItemButton>

                  <ListItemButton
                    disabled={cargando || arrayExport.length === 0}
                    onClick={async () => {
                      await setcargando(true);

                      await setTimeout(async () => {
                        await funcExcel();
                        setcargando(false);
                        setopen(false);
                      }, 500);
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar className={classes.success}>
                        <MenuBook />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Excel" />
                  </ListItemButton>
                  <ListItemButton
                    disabled={cargando || mes === ""}
                    onClick={async () => {
                      await setcargando(true);

                      await setTimeout(async () => {
                        await funcExcel(mes);
                        setcargando(false);
                        setopen(false);
                      }, 500);
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar className={classes.success}>
                        <MenuBook />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Excel (Mensual)" />
                  </ListItemButton> 
                  <ListItemButton
                    disabled={cargando || arrayExport.length === 0}
                    onClick={async () => {
                      await setcargando(true);

                      await setTimeout(async () => {
                        await funcExcel2();
                        setcargando(false);
                        setopen(false);
                      }, 500);
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar className={classes.success}>
                        <MenuBook />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="BP_CASH" />
                  </ListItemButton>
                </List>
              </>
            )}
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Mes"
              type="month"
              value={mes}
              onChange={(e) => {
                setmes(e.target.value);
              }}
              fullWidth
            />
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};

export default memo(ExportDialog);
